import '../../monitoring/charts/chart_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.PieGraphChartView extends Monitoring.Views.Charts.ChartView
  initialize: ({@data}) ->

  renderChart: ->
    @chart = new Highcharts.Chart(@_highchartsOptions())

  setChartWidth: (singleDimensionView) ->
    el = singleDimensionView.$el
    isMaximized = singleDimensionView.widget.get('is_maximized')
    el.toggleClass('full-width-chart', isMaximized)
    el.toggleClass('half-width-chart', !isMaximized)

  _highchartsOptions: ->
    {
      chart: {
        type: 'pie',
        renderTo: @$el[0]
      },
      legend: {
        align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        itemMarginTop: 1,
        labelFormat: '{name} {y}: {percentage:.1f}%'
      },
      title: {
        text: null
      },
      exporting: {
        enabled: false
      },
      tooltip: {
        headerFormat: null,
        pointFormat: '{point.name} {point.y}: {point.percentage:.1f}%'
      }
      plotOptions: {
        pie: {
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true,
          events: {
            click: (event) => @trigger('singledimension:click', event.point.id)
          }
        }
      }
      series: @_createSeries()
    }

  updateData: (data) =>
    @data = data
    @chart.update({series: @_createSeries()}, true, true)

  _createSeries: ->
    cc = @customColors()
    [{
      data: @data.map((value) ->
        {
          id: value.id,
          name: value.x,
          color: cc[Object.keys(cc).find((a) => value.id.toString().toLowerCase().match(a))],
          y: value.y
        }
      )
    }]
